import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'mpro-wizard-complete',
    templateUrl: './wizard-complete.component.html'
})
export class WizardCompleteComponent {
    @ViewChild(TemplateRef)
    public content: TemplateRef<any>;
    @Input() public title: string;
    @Input() public subtitle: string;
}